import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { ApiError } from "@/lib/api";

export default function TwoFactorChallenge() {
  const { challenge2fa, logout } = useAuth();
  const nav = useNavigate();
  const [mode, setMode] = useState<"code" | "recovery">("code");
  const [code, setCode] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      if (mode === "code") await challenge2fa(code);
      else await challenge2fa(undefined, code);
      nav("/", { replace: true });
    } catch (err) {
      const msg = err instanceof ApiError ? err.message : (err as Error).message;
      setError(msg);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="auth-shell">
      <div className="card" style={{ width: 380, padding: 28 }}>
        <h1 style={{ fontSize: 22 }}>Two-factor authentication</h1>
        <p className="muted" style={{ fontSize: 13, marginTop: 6 }}>
          {mode === "code"
            ? "Enter the 6-digit code from your authenticator app."
            : "Enter one of your single-use recovery codes."}
        </p>

        <form onSubmit={onSubmit} className="col" style={{ gap: 14, marginTop: 18 }}>
          <input
            className="input"
            inputMode={mode === "code" ? "numeric" : "text"}
            pattern={mode === "code" ? "[0-9]{6}" : undefined}
            maxLength={mode === "code" ? 6 : 32}
            placeholder={mode === "code" ? "000000" : "xxxxxxxxxx"}
            autoFocus
            required
            value={code}
            onChange={(e) => setCode(e.target.value.trim())}
            style={{ fontFamily: "var(--font-mono)", fontSize: 18, letterSpacing: 4, textAlign: "center" }}
          />
          {error && <div className="pill pill-fail" style={{ alignSelf: "flex-start" }}>{error}</div>}
          <button type="submit" className="btn btn-primary btn-lg" disabled={submitting}>
            {submitting ? "Verifying…" : "Verify"}
          </button>
        </form>

        <div className="divider" />
        <div className="row" style={{ justifyContent: "space-between" }}>
          <button className="btn btn-ghost btn-sm" onClick={() => setMode(mode === "code" ? "recovery" : "code")}>
            Use {mode === "code" ? "a recovery code" : "authenticator code"}
          </button>
          <button className="btn btn-ghost btn-sm" onClick={() => { void logout(); nav("/auth/login", { replace: true }); }}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
